@if (loading() || error()) {
  <app-modal-loading-section
    message="modals.errors.order"
    [loading]="loading()"
    [(error)]="error"
    (errorChange)="reloadOrder.emit()"
  ></app-modal-loading-section>
} @else if (order(); as order) {
  <section>
    <onyx-information-heading>
      {{ 'labels.order' | translate }}

      <onyx-link subheading color="gray" (click)="openOrderModal(order.uuid)">
        {{ order.identifier }}
      </onyx-link>

      <onyx-icon-button
        actions
        variant="transparent"
        color="gray"
        [size]="32"
        icon="map-view-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnMap"
        (click)="showOnMap()"
      ></onyx-icon-button>
    </onyx-information-heading>

    <div class="boxes">
      <app-modal-telematics-status
        [vehicle]="vehicle()"
        type="icon-box"
        [close$]="close$()"
      ></app-modal-telematics-status>

      <onyx-icon-box
        class="clickable"
        color="gray"
        [hasTransparentBackground]="true"
        [size]="16"
        [gap]="8"
        [isCentered]="true"
        (click)="openContractorModal(order.basicInformation.sender)"
      >
        <onyx-icon name="contractor-outlined" [size]="16"></onyx-icon>

        {{ order.basicInformation.sender.companyProfile.displayName }}
      </onyx-icon-box>

      @if (distanceData(); as distanceData) {
        <div class="box">
          <div class="bar-container">
            <onyx-progress
              [value]="distanceData.elapsed"
              [max]="distanceData.distance"
            ></onyx-progress>
          </div>

          <div>
            {{ distanceData.elapsed | onyxDistance: false : 'km' }}

            <span class="f-muted">
              / {{ distanceData.distance | onyxDistance: true : 'km' }}
            </span>
          </div>
        </div>
      }

      @if (pointData(); as pointData) {
        <onyx-icon-box
          color="gray"
          [hasTransparentBackground]="true"
          [size]="16"
          [gap]="8"
          [isCentered]="true"
        >
          <onyx-icon [name]="pointData.icon" [size]="16"></onyx-icon>

          {{
            `${DictionaryCode.ORDER_POINT_TYPE}.${pointData.type}` | translate
          }}
        </onyx-icon-box>
      }
    </div>
  </section>

  @if (isVehicle() != null && loadedSemiTrailerPoint(); as point) {
    @let loadedSemiTrailer = order.basicInformation.loadedSemiTrailer;

    <section>
      <onyx-information-heading>
        {{ 'labels.semiTrailerPickup' | translate }}

        @if (loadedSemiTrailer.registrationNumber; as registrationNumber) {
          {{ registrationNumber }}
        } @else if (loadedSemiTrailer.data; as loadedSemiTrailer) {
          <onyx-link
            color="black"
            font="f-heading-s"
            (click)="openFleetModal(loadedSemiTrailer)"
          >
            {{ loadedSemiTrailer | fleetIdentifier }}
          </onyx-link>
        }
      </onyx-information-heading>

      <app-route-point [point]="point" variant="preview"></app-route-point>
    </section>
  }
} @else {
  <app-no-active-order
    [manualProposalOrderUuid]="vehicle()?.manualProposalOrderUuid"
  ></app-no-active-order>
}
